import { Component, EventEmitter, Inject, OnInit, Output, HostListener ,ElementRef,Renderer2,ViewChild} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { RxjsService } from '../services/rxjs.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InfoService } from '../services/info.service';
import { AppService } from '../services/app.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-card-on-file',
  // template: './card-on-file.component.html',
  templateUrl: './card-on-file.component.html',
  styleUrls: ['./card-on-file.component.css']
})
export class CardOnFileComponent implements OnInit {
  url: any;
  showNewPayment: boolean = false;
  okbtnCalled: boolean = false;
  cardObj: any;
  showNext = true;
  showSave = false;
  showPrev = false;
  cardDetails = true;
  cardOwnerDetails = false;
  currentActiveBtn = 1;
  isSaveEnabled: boolean;
  poKey: string;
  refId:any;
  recurring: boolean = false;
  customerInitiated: boolean = false;
  isRequestDeposit:boolean = false;
  saveCardApi: boolean = false;
  purchaseType: any;
  isPageLoader: boolean;
  cardCaptchaToken: string | null = null;
  cardCaptchaError: string | null = null;
  showCaptchaForCard:boolean = false;

  constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute, private infoService: InfoService, private appService: AppService,private router: Router,private elRef: ElementRef,private el: ElementRef, private renderer: Renderer2,
    public dialogRef: MatDialogRef<CardOnFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public rxjsSupport: RxjsService) {
    this.purchaseType = this.infoService.selectedPurchaseType;
    this.isRequestDeposit = this.data.isRequestDeposit;
    if (this.data.link.includes("runloyal.com")) {
      this.showNewPayment = true;
      (<HTMLElement>document.getElementsByClassName("mat-dialog-container")[0]).classList.add("fivserPopup")
      if(this.data.link.includes("referenceId")){
        this.refId=this.extractValueFromParam(this.data.link,'referenceId');
        this.poKey = this.extractValueFromParam(this.data.link,'petOwnerKey');
        this.getAddCardLink('referenceId',this.refId);
      }else{
        this.poKey = this.extractValueFromParam(this.data.link,'petOwnerKey');
        this.getAddCardLink('petOwnerKey',this.poKey);
      }
    }
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.link);
  }

  getAddCardLink(key: any,value:any) {
    this.infoService.getAddCardLink(key,value).subscribe((res: any) => {
      if (res.data && res.data.urls) {
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.urls.FiservTokenizer);
        if(!this.data.link.includes("referenceId")){
          (<HTMLElement>document.getElementsByClassName("payment-detail")[0]).classList.add("hide");
        }
        if (res.data.paymentInfo) {
          if (res.data.paymentInfo.amount) {
            let total = res.data.paymentInfo.amount;
            (<HTMLElement>document.getElementById('total')).innerHTML = "$" + this.formatMoney(total);
          } else { 
            (<HTMLElement>document.getElementById('total')).innerHTML = "";
          }
          if (res.data.paymentInfo.ccCharges) {
            let ccCharges = res.data.paymentInfo.ccCharges;
            (<HTMLElement>document.getElementById('serviceFee')).innerHTML = "$" + this.formatMoney(ccCharges);
          } else {
            (<HTMLElement>document.getElementById('serviceFeeMessage')).innerHTML = "<span style='color: red; font-weight: bold;'>(If a service fee is configured, it will be included in the final invoice.)</span>";
            (<HTMLElement>document.getElementById('serviceFee')).innerHTML = "";
            (<HTMLElement>document.getElementsByClassName("fee")[0]).classList.add("hide");
          }

          if (res.data.paymentInfo.amount && res.data.paymentInfo.ccCharges) {
            (<HTMLElement>document.getElementById('payableAmount')).innerHTML = "$" + this.formatMoney(res.data.paymentInfo.amount + res.data.paymentInfo.ccCharges);
          } else if (res.data.paymentInfo.amount && !res.data.paymentInfo.ccCharges) {
            (<HTMLElement>document.getElementById('payableAmount')).innerHTML = "$" + this.formatMoney(res.data.paymentInfo.amount);
            (<HTMLElement>document.getElementsByClassName("amount")[0]).classList.add("hide");
          }



          if (res.data.paymentInfo.petOwnerName) {
            let name = res.data.paymentInfo.petOwnerName;
            (<HTMLImageElement>document.getElementById('nameInput')).src = name;
          }
        }
      }
    })
  }

  formatMoney(number: any, decPlaces: number = 2, decSep: string = ".", thouSep: string = ",") {
    decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
      decSep = typeof decSep === "undefined" ? "." : decSep;
    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
    var sign = number < 0 ? "-" : "";
    var i:any = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
    var j = (j = i.length) > 3 ? j % 3 : 0;

    return sign +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces ? decSep + Number(Math.abs(number - i).toFixed(decPlaces).slice(2)) : "");
  }

  extractValueFromParam(url: string, key: string): string | null {
    const pattern = new RegExp(`${key}=([^&]+)`);
    const match = url.match(pattern);
    return match ? match[1] : null;
  }

  validateInput = function () {
    if (this.cardObj && this.cardObj.expiry && this.cardObj.message) {
      this.currentActiveBtn = 2;
      this.showNext = false;
      this.showSave = true;
      this.showPrev = true;
      Array.from(document.getElementsByClassName("cardtypesbox")).forEach((element: HTMLElement) => {
        element.classList.add("hide");
      });
      Array.from(document.getElementsByClassName("cardtypesdetailbox")).forEach((element: HTMLElement) => {
        element.classList.remove("hide");
      });
      this.updateClassTobtn()
      return true;
    }
  }

  updateClassTobtn() {
    if (this.currentActiveBtn == 1) {
      (<HTMLElement>document.getElementsByClassName("step_1")[0]).classList.add("active");
      (<HTMLElement>document.getElementsByClassName("step_2")[0]).classList.remove("active");
    } else {
      (<HTMLElement>document.getElementsByClassName("step_2")[0]).classList.add("active");
      (<HTMLElement>document.getElementsByClassName("step_1")[0]).classList.remove("active");
    }
  }

  goBack() {
    this.showNext = true;
    this.showSave = false;
    this.showPrev = false;
    Array.from(document.getElementsByClassName("cardtypesbox")).forEach((element: HTMLElement) => {
      element.classList.remove("hide");
    });
    Array.from(document.getElementsByClassName("cardtypesdetailbox")).forEach((element: HTMLElement) => {
      element.classList.add("hide");
    });
    this.currentActiveBtn = 1;
    this.updateClassTobtn()
  }

  enableButtonOnEnter() {
    const name = (document.getElementById('nameInput') as HTMLInputElement).value;
    const postal = (document.getElementById('postalInput') as HTMLInputElement).value;
    if (name.trim() !== '' && postal.trim() !== '') {
      this.isSaveEnabled = true;
    } else {
      this.isSaveEnabled = false;
    }
  }

  validateToken() {
    if (this.okbtnCalled == false) {
      this.okbtnCalled = true
      if (this.cardObj && this.cardObj.expiry && this.cardObj.message) {
        var nameInput = document.getElementById("nameInput") as HTMLInputElement;
        var postalInput = document.getElementById("postalInput") as HTMLInputElement;
        if (!this.validateInput()) {
          this.okbtnCalled = false;
          return;
        }
        if (!this.cardCaptchaToken && this.isRequestDeposit) {
          this.showCaptchaForCard = true;
          this.okbtnCalled = false
          this.cardCaptchaError = "Please verify that you're not a robot.";
          return;
        }
        this.showPageContentLoader();
        this.saveCardApi = true;
        var appKey = this.appService.applicationKey;
        var client = this.appService.tenantKey;
        var baseUrl = this.appService.baseUrl
        // var return_url = "https://suitepaws-uat.runloyal.com/book/#/cardadd"
        var return_url = window.location.href;
        // var return_url ="http://localhost:4200/"
        if(!this.isRequestDeposit){
          var url = baseUrl + "/payment-service/gatewayCardTokenCallback?applicationKey=" + appKey + "&merchantKey=" + client + "&customerKey=" + this.poKey + "&expiry=" + this.cardObj.expiry + "&account=" + this.cardObj.message + "&refereneIdKey=00" + "&name=" + encodeURIComponent(nameInput.value) + "&postal=" + postalInput.value + "&recurring=" + this.recurring + "&customerInitiated=" + this.customerInitiated + "&return_url=" + return_url;
        }else{
          var url = baseUrl + "/payment-service/gatewayPaymentCallback?applicationKey=" + appKey + "&merchantKey=" + client + "&refereneIdKey=" + this.extractValueFromParam(this.data.link,'referenceKey') + "&expiry=" + this.cardObj.expiry + "&account=" + this.cardObj.message + "&name=" + encodeURIComponent(nameInput.value) + "&postal=" + postalInput.value + "&recurring=" + this.extractValueFromParam(this.data.link,'recurring') + "&customerInitiated=" + this.extractValueFromParam(this.data.link,'customerInitiated')+ "&return_url=" + window.location.href + "thankyou";
        }
        console.log("***********--->" + url)
        // window.location.href = url;
        this.infoService.getCardTokenCallBack(url).subscribe((res: any) => {
          console.log("response", res)
          this.dialogRef.close();
          this.hidePageContentLoader();
          Swal.fire({
            title: 'Success',
            text: 'Card added successfully',
            icon: 'success',
            confirmButtonText: 'Ok'
          }).then((result) => {
            if (result.isConfirmed) {
            }
          });
          this.closeDialog()
        },
          (error) => {
            this.hidePageContentLoader();
            this.closeDialog()
          }
        )

      }
      else {
        this.okbtnCalled = false;
      }
    }
  }

  closeDialog(){
    if (this.saveCardApi && this.isRequestDeposit && this.purchaseType == 'service') {
      if(this.data.showEndTimeInSummary){
        var message = `Thank you for your payment . \n Your appointment has been successfully confirmed.\nWe can't wait to see ${this.data.petName} at ${this.data.startTime} To ${this.data.endTime} at ${this.data.address}`;
      }
      else{
        var message = `Thank you for your payment . \n Your appointment has been successfully confirmed.\nWe can't wait to see ${this.data.petName} at ${this.data.startTime} at ${this.data.address}`;
      }
    
      this.infoService.getAppointmentDetail(this.infoService.appointmentKey).subscribe((res: any) => {
        if (res && res.data) {
          if (res.data.status != 'CONFIRMED') {
            Swal.fire({
              icon: 'success',
              allowOutsideClick: false,
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: 'Okay',
              html: `Thank you for your payment . \n Your appointment request has been received and will be reviewed shortly .\n We are looking forward to seeing ${this.data.petName}`
            }).then((result: any) => {
              if (result.isConfirmed) {
                this.reload()
              }
            })
          }
          else {
            Swal.fire({
              icon: 'success',
              allowOutsideClick: false,
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: 'Okay',
              html: message
            }).then((result: any) => {
              if (result.isConfirmed) {
                this.reload()
              }
            })
          }
        }
      })
      this.dialogRef.close();
    } else if(this.purchaseType != 'service'){
      if(this.data.autoRenewal == 'true' || this.data.autoRenewal == true){
        this.infoService.storeCard(this.extractValueFromParam(this.data.link,'referenceKey')).subscribe((res: any) => {
          if (res && res.data) {
            console.log("store card response", res)
          }
        })
        Swal.fire({
          icon: 'success',
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Okay',
          html: `Thank you for your payment . \n Your payment has been successfully processed.  \n Your card has been securely saved for auto-renewal payments. \n We look forward to seeing you.`,
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.reload()
          }
        })
        this.dialogRef.close();
      }
      else{
        Swal.fire({
          icon: 'success',
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Okay',
          html: `Thank you for your payment . \n Your payment has been successfully processed. \n We look forward to seeing you.`,
          input: 'checkbox',
          inputPlaceholder: ' Save this card securely for future transactions',
          inputValue: 1
        }).then((result: any) => {
          if (result.isConfirmed) {
            if (result.value) {
              this.showPageContentLoader();
              this.infoService.storeCard(this.extractValueFromParam(this.data.link,'referenceKey')).subscribe((res: any) => {
                if (res && res.data) {
                  this.hidePageContentLoader();
                  console.log("store card response", res)
                  this.reload()
                }
              })
            }
            else{
              this.reload()
            }
          }
        })
        this.dialogRef.close();
      }
      this.dialogRef.close();
    }
    else{
      this.dialogRef.close();
    }
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    // console.log(event);
    if (event && event.data) {
      var token = JSON.parse(event.data);
      this.cardObj = token;
      this.okbtnCalled = false;
      this.validateInput();
      this.updateClassTobtn();
    }
  }



  ngOnInit(): void {
  }

  Close() {
    if(this.saveCardApi && this.isRequestDeposit){
      this.dialogRef.close();
      this.router.navigate(["/"]).then(() => window.location.reload());
    }else{
      this.dialogRef.close();
    }
  }

  iframeUrlChange(event: any) {
    if(event.href && event.href.includes("thankyou")){
      this.saveCardApi = true;
    }
  }

  show() {
    console.log(this.url);
  }

  ngAfterViewInit() {
    const iframe: HTMLIFrameElement = this.elRef.nativeElement.querySelector('iframe');
    if (iframe) {
      iframe.onload = () => {
        this.iframeUrlChange(iframe.contentWindow.location);
      };
    }
  }

  reload(){
    window.location.reload()
  }

  showPageContentLoader(): void {
    this.isPageLoader = true;
    const pageSidebar = this.el.nativeElement.querySelector('#page-sidebar');
    const pageContentLoader = this.el.nativeElement.querySelector('.page-content-loader');
    if (pageSidebar && pageContentLoader) {
      const marginLeft = `${pageSidebar.offsetWidth}px`;
      this.renderer.setStyle(pageContentLoader, 'margin-left', marginLeft);
    }
  }

  hidePageContentLoader(): void {
    this.isPageLoader = false;
  }

  onCardCaptchaResolved(token: string) {
    this.cardCaptchaToken = token;
    this.cardCaptchaError = null;
    if(this.cardCaptchaToken){
      this.validateToken()
    }
  }
}
